import { useFormContext } from '@hooks/react-hook-form';

import ApplicationCard from '../../../../../application-card';

import ApplicationCamera from '../../application-camera';

import { IdentityPhotoProps } from './types';

const IdendityPhoto = (props: IdentityPhotoProps) => {
  const { readonly } = props;
  const {
    formState: { isSubmitting, isSubmitSuccessful },
  } = useFormContext();

  return (
    <ApplicationCard className='section-identity-photo'>
      <ApplicationCamera
        readonly={readonly}
        name='ktp'
        label='Foto KTP'
        cameraFacing='back'
        isLoading={isSubmitting && !isSubmitSuccessful}
      />
      <ApplicationCamera
        readonly={readonly}
        name='selfieKtp'
        label='Foto Selfie'
        isLoading={isSubmitting && !isSubmitSuccessful}
      />
    </ApplicationCard>
  );
};

export default IdendityPhoto;
